import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function Expert() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-20 sm:py-32 bg-white relative overflow-hidden" data-id="element-33">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-35">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2F4538] mb-8 leading-tight" data-id="element-36">
            El problema NO sos vos.
            <br data-id="element-37" />
            <span className="text-[#B4A7D6]" data-id="element-38">Es que nadie te enseñó esto.</span>
          </h2>

          <div className="text-lg sm:text-xl text-[#1a1a1a]/80 space-y-6 text-left max-w-3xl mx-auto" data-id="element-39">
            <p data-id="element-40">
              La ansiedad, el estrés, el insomnio, las energías pesadas... no
              son normales.
            </p>
            <p data-id="element-41">
              Pero vivimos en un contexto donde todo el mundo te dice que "así
              es la vida", que "tenés que aguantar", que "todos estamos igual".
            </p>
            <p className="font-bold text-[#2F4538] text-2xl text-center py-4" data-id="element-42">
              Mentira.
            </p>
            <p data-id="element-43">Nuestras abuelas sabían algo que nosotras olvidamos:</p>
            <div className="relative my-4" data-id="element-44">
              <div className="absolute -inset-2 bg-gradient-to-r from-[#B4A7D6]/20 via-[#B4A7D6]/30 to-[#B4A7D6]/20 rounded-2xl blur-xl" aria-hidden="true" data-id="element-45"></div>
              <div className="relative bg-gradient-to-br from-[#B4A7D6]/15 to-[#B4A7D6]/5 border-l-4 border-[#B4A7D6] rounded-2xl px-6 py-5 sm:px-8 sm:py-6 shadow-md" data-id="element-46">
                <p className="font-bold text-[#2F4538] text-xl sm:text-2xl text-center leading-snug" data-id="element-47">
                  Tu cuerpo y tu energía necesitan{' '}
                  <span className="text-[#B4A7D6] underline decoration-[#B4A7D6]/40 decoration-2 underline-offset-4" data-id="element-48">
                    LIMPIARSE
                  </span>{' '}
                  tanto como tu casa.
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 mb-16" data-id="element-49">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-[#F5F0E8] p-8 rounded-3xl border border-[#D4AF37]/30" data-id="element-50">
            <h3 className="text-2xl font-bold text-[#2F4538] mb-6" data-id="element-51">
              Por eso los rituales ancestrales funcionan:
            </h3>
            <p className="text-[#1a1a1a]/80 mb-6" data-id="element-52">
              Hace siglos, las mujeres usaban baños de pies con hierbas, flores
              y sal para:
            </p>
            <ul className="space-y-4 mb-6" data-id="element-53">
              {['Sacar el cansancio del cuerpo', 'Limpiar la energía negativa del día', 'Calmar la mente antes de dormir', 'Atraer buenas vibraciones para el hogar'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-54">
                  <CheckCircle2 className="w-6 h-6 text-[#8B9D83] shrink-0" data-id="element-55" />
                  <span className="text-[#1a1a1a]/90 font-medium" data-id="element-56">{item}</span>
                </li>)}
            </ul>
            <p className="text-[#1a1a1a]/80 italic" data-id="element-57">
              ¿Y sabés qué? No era magia esotérica complicada. No necesitaban
              ingredientes raros. No dependían de nadie. Era simple. Poderoso. Y
              estaba en SUS MANOS.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="bg-white p-8 rounded-3xl border border-red-100 shadow-sm" data-id="element-58">
            <h3 className="text-2xl font-bold text-[#2F4538] mb-6" data-id="element-59">
              Hoy, en pleno 2026, en medio del caos argentino...
            </h3>
            <p className="text-[#1a1a1a]/80 mb-6" data-id="element-60">
              ...la mayoría de nosotras perdimos esa conexión. Buscamos
              soluciones afuera:
            </p>
            <ul className="space-y-4 mb-6" data-id="element-61">
              {['Pastillas para la ansiedad (con efectos secundarios)', 'Terapia (carísima y con lista de espera)', 'Masajes (que duran 2 días)', 'Retiros espirituales (que hacemos 1 vez al año si llegamos)'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-62">
                  <XCircle className="w-6 h-6 text-red-400 shrink-0" data-id="element-63" />
                  <span className="text-[#1a1a1a]/90" data-id="element-64">{item}</span>
                </li>)}
            </ul>
            <p className="text-[#1a1a1a]/80 font-medium" data-id="element-65">
              ¿El resultado? Dependemos de horarios, turnos, plata, y otras
              personas para sentirnos bien.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-center" data-id="element-66">
          <p className="text-2xl sm:text-3xl font-bold text-[#2F4538] leading-relaxed" data-id="element-67">
            Pero existe otra forma.
            <br data-id="element-68" />
            <span className="text-[#B4A7D6]" data-id="element-69">
              Una forma que está en tus manos.
            </span>{' '}
            Que podés hacer HOY. Que no te cuesta una fortuna. Y que funciona
            desde la primera vez.
          </p>
        </motion.div>
      </div>
    </section>;
}